import React from 'react';

import './TabWidget.css';

interface TabWidgetProps {
    visible: boolean
    width: number;
    tabs: {name: string, enabled: boolean}[];
    selected: string;

    ontabchange: (tab: string) => void;
    onshowhidecontrols: () => void;
}

class TabWidget extends React.Component<TabWidgetProps> {
    constructor(props: TabWidgetProps) {
        super(props);

        this.tabClick = this.tabClick.bind(this);
        this.showHideControls = this.showHideControls.bind(this);
    }

    tabClick(event: React.MouseEvent) {
        const target = event?.target;
        if (!(target instanceof HTMLElement)) {
            throw "Tab click target is of type " + (typeof target) + ", expected HTMLElement";
        }

        const clicked_tab = target.childNodes[0].textContent;
        if (clicked_tab !== null && clicked_tab != this.props['selected']) {
            this.props['ontabchange'](clicked_tab);
        }
    }

    showHideControls() {
        if (this.props['onshowhidecontrols'] !== undefined) {
            this.props['onshowhidecontrols']();
        }
    }

    render() {
        const showhide_character = this.props['visible'] ? '\u25bc' : '\u25b2';
        const font_ems = Math.min(1, this.props['width'] / 500);
        const showhide_nudge = this.props['visible'] ? + (1 - font_ems) * 15 : -26;

        return (
            <div id='tab-controls'>
                <div id='showhide-controls' 
                    style={{'transform': 'translate(0px, ' + showhide_nudge + 'px)'}}
                    onClick={this.showHideControls}>
                    {showhide_character}
                </div>
                <ul id='tabs' style={{"fontSize": font_ems + "rem"}}>
                    {this.props['tabs'].map(t => {
                        let cls = ''
                        let click_handler = this.tabClick;

                        if (t['name'] == this.props['selected']) {
                            cls = 'selected';
                        }
                        if (!t['enabled']) {
                            cls = 'disabled';
                            click_handler = () => {};
                        }

                        return (
                        <li className={cls} key={t['name'].toLowerCase()} onClick={click_handler}>
                            {t['name']}
                        </li>);
                    })}
                </ul>
            </div>
        );
    }
}

export default TabWidget;